import consolv from 'lib/consolv';
import uniqueId from 'lib/uniqueId';

const legacyProps = [
  'getInitializedSlots',
  'SniAdsError',
  'playerCreated',
  'getVersion',
  'getKeyValues',
  'getValueByKey',
  'getNetworkId',
  'getEnvironment',
  'getDfpHierarchy',
  'getSlotSizes',
  'getTargetedKeyValues',
  // 'getSlotConfig',
  'getCurrentPageTargeting',
  'setKeyValue',
  'getSlot',
  'refreshSlot',
  'refreshSlots',
  'reloadTargeting',
  'getInitCfg',
  '_cleanValue',
  '_setSlotTargeting',
  '_submitNapalm',
  // 'Utility',
  // 'Gallery',
  // 'River',
  // 'Restriction',
];

const legacyPropsGallery = [
  'setRefreshRate',
  // 'setInterstitialSlot',
  'reset',
  'resetGallerySlots',
  'getState',
  'clearInterstitial',
  'getDescriptorData',
  'getConfigData',
];

/**
 * Provides legacy functions to sites that still reference them
 * @access private
 */
export default function generateLegacyAdapter(MCP) {
  Object.assign(window.SniAds, {
    init: (...args) => {
      consolv.log('init', ...args);
      MCP.initialize(...args);
    },
    Event: {
      publish: (...args) => {
        MCP.ready.then(() => {
          if (args[0] === '_newSlotDefined') {
            const elements = document.querySelectorAll('[id^=dfp_bigbox_]');
            const newElements = Array.from(elements).filter(element => !MCP.slots.has(element));

            newElements.forEach((element) => {
              MCP.appendSlot(element, { type: 'dfp_bigbox' });
            });

            return;
          }
          consolv.log('SniAds.Events.publish', ...args);
        });
      },
      subscribe: (event, callbackFunction, priority) => {
        switch (event) {
          case 'slotRenderComplete': {
            MCP.addEventListener('slotRenderComplete', callbackFunction, { priority });
            break;
          }

          default: {
            consolv.log('Unmapped subscribe: ', event, callbackFunction, { priority });
          }
        }
      },
      unsubscribe: (event, callbackFunction) => {
        switch (event) {
          case 'slotRenderComplete': {
            MCP.removeEventListener('slotRenderComplete', callbackFunction);
            break;
          }

          default: {
            consolv.log('Unmapped unsubscribe: ', event, callbackFunction);
          }
        }
      },
    },
    ready: (callbackFunction) => {
      if (MCP.isReady) {
        callbackFunction();
      } else {
        MCP.addEventListener('initialSlotsLoaded', callbackFunction);
      }
    },
    getDefinedSlots: () => {
      const slots = {};
      Array.from(MCP.slots).forEach(([element, slot]) => { // eslint-disable-line no-unused-vars
        slots[slot.id] = slot.DFPSlot;
      });
      return slots;
    },
    appendSlot: (element, tag, targetingArg = {}, preventLoadArg = false) => {
      consolv.log('Legacy appendSlot', tag, element);
      // Wrapped in a immediately resolving timeout to allow the promises to be updated before
      // checking them. This should be refactored
      window.setTimeout(() => {
        // Potential race condition because multiple calls will catch SourceOfTruth in a not ready
        // state. Check to make sure SourceOfTruth is ready before proceeding
        Promise.all([MCP.ready, MCP._sourceOfTruth.ready]).then(() => {
          const configuration = MCP.Configurator.getConfiguration();
          if (configuration.overrideLegacyAppendSlot) {
            MCP.update();
            return null;
          }

          let targeting = targetingArg;
          let preventLoad = preventLoadArg;
          if (typeof targetingArg === 'boolean') {
            targeting = {};
            preventLoad = targetingArg;
          }

          // preventLoad = false;

          let node;

          if (element.substring(0, 1) === '#') {
            node = document.querySelector(element);
          } else {
            node = document.getElementById(element) || document.querySelector(`.${element}`);
          }

          if (!node) return null;

          const id = uniqueId(node.id || tag);
          if (node.id !== id) node.id = id;

          MCP.appendSlot(node,
            { type: tag, additionalTargeting: targeting, immediatelyLoad: !preventLoad });

          return element;
        });
      }, 1);
    },
    appendSlots: (...args) => {
      consolv.log('appendSlots', ...args);
    },
    getSlotConfig: () => {
      consolv.log('MCP: Legacy getSlotConfig called');
      if (MCP.isReady) MCP.update();
    },
    Iframe: {
      resizeSlot: MCP.utilities.resizeSlotIFrame,
    },
    River: {
      repeatBigbox: (config) => {
        // const element = document.querySelector(`${args[0].target}
        //   .${args[0].adClass.split(' ').join('.')}`);
        consolv.log('repeatBigbox', config);
      },
    },
    Gallery: {
      init: (legacyCfg = {}) => {
        /* eslint-disable camelcase */
        const { container, dismiss_elts } = legacyCfg;
        const configuration = {
          galleryContainer: document.querySelector(container),
          galleryNavigationButtons: dismiss_elts,
        };
        /* eslint-enable camelcase */

        MCP.initializePhotoGallery(configuration);
      },
      isInit: () => MCP.PhotoGallery !== undefined,
      next: () => MCP.PhotoGallery && MCP.PhotoGallery.next(),
      previous: () => MCP.PhotoGallery && MCP.PhotoGallery.previous(),
      setSyncSlot: (slotId) => {
        // MCP.PhotoGallery.setSyncSlot('bigbox', `#${slotId}`);
      },
      setInterstitialSlot: (elementId) => {
        // MCP.PhotoGallery.setSyncSlot('interstitial', `#${elementId}`);
      },
    },
  });

  legacyPropsGallery.forEach((key) => {
    window.SniAds.Gallery[key] = (...args) => { consolv.log(`Gallery.${key}`, ...args); };
  });

  legacyProps.forEach((key) => {
    window.SniAds[key] = (...args) => {
      console.log(`The function 'SniAds.${key}' is deprecated. Please contact the Ad Department.`);
    };
  });
}
